import * as yup from 'yup';

import nls from './nls/EnterAmount';
import { createTranslator } from '~/lib/nls-helper';

const NLS = createTranslator(nls);

const schema = (minAmount, maxAmount) => yup.object().shape({
  requestedAmount: yup
    .number()
    .min(minAmount, `${NLS`The amount you entered must be greater than $`}${minAmount} ${NLS`M.N.`}`)
    .max(maxAmount, NLS`Amount exceeds available credit limit`)
    .required(NLS`Please enter an amount`),
});

export default schema;
